export default "__VITE_ASSET__BT5rTIOE__"